import React, { useState, useEffect } from "react";
import {  Col, Image, Card } from "react-bootstrap";
import { IPUrl } from "../../commons/IPAddress";
import {  useNavigate, useParams, useLocation } from 'react-router-dom'
import Media from "../../components/Media";
import AllHeader from "../../components/AllHeader";
import Parent from "../../container/Parent";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";


function InternalPlaces() {
  const params = useParams();
  const [seenFile, setSeenFile] = useState([]);
  const [Id, setId] = useState(params.requestId);
  const location = useLocation();
  const data = location.state;


  useEffect(() => {
    axiosInstance.post("GetPlaces", {
      Id: Id,
    })
      .then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data)
          // setId(params.requestId)
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  }, [Id]);

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>{data}</span>
      </AllHeader>
      <Parent>
        {seenFile.map((data, index) => {
          return (
            <Col xs={12} key={index}>
              <div className="rgc-internal-news">
                <Image variant="top" src={IPUrl + "/UploadedFile/Places/Ssn/" + data.Pic}
                  height={200}
                  className="img-fluid m-0 col-12 col-md-5 float-none float-md-start" />
                <Card.Body>
                  <Card.Title>
                    {data.Tittle}
                  </Card.Title>
                  <p style={{ fontSize: "0.7em" }}><i className="fa fa-map-marker-alt rgc-text-icon" aria-hidden="true"  ></i>
                    {data.Chekideh}
                  </p>
                  <Card.Text>
                    <Card.Text dangerouslySetInnerHTML={{
                      __html: decodeURIComponent(data.Text)
                        .replaceAll("/Content/UserFiles/", `${IPUrl}/Content/UserFiles/`)
                    }}>
                    </Card.Text>
                    <hr />
                    {/* social media */}
                    <div className="rgc-media-style">
                      <Media address={`/Internalplaces/${Id}`} title={data.Tittle} />
                      <span> اشتراک گذاری</span>
                    </div>
                  </Card.Text>
                </Card.Body>
              </div>
            </Col>
          )
        })
        }
      </Parent>
    </div>
  );
}

export default InternalPlaces;
